/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
import { useIntl } from 'react-intl'
import { KTSVG } from '../../../helpers'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { AsideMenuItem } from './AsideMenuItem'

export function AsideMenuLeader() {
  const intl = useIntl()

  return (
    <>
      <AsideMenuItem
        to='/dashboard'
        icon='/media/icons/duotune/art/art002.svg'
        title={intl.formatMessage({ id: 'MENU.DASHBOARD' })}
        fontIcon='bi-app-indicator'
      />
      <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Quản lý vùng miền</span>
        </div>
      </div>
      <AsideMenuItem
        to='/apps/user-management/users'
        icon='/media/icons/duotune/general/gen051.svg'
        title='User management'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/apps/sales'
        icon='/media/icons/duotune/art/art002.svg'
        title='Doanh số'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/apps/partners'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Đối tác'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/apps/installment-package'
        icon='/media/icons/duotune/art/art002.svg'
        title='Gói trả góp'
        fontIcon='bi-layers'
      />
      <AsideMenuItem
        to='/apps/region-management/regions'
        icon='/media/icons/duotune/general/gen019.svg'
        title='Vùng miền - Văn phòng'
        fontIcon='bi-layers'
      />
      <div className='menu-item'>
        <div className='menu-content'>
          <div className='separator mx-1 my-4'></div>
        </div>
      </div>
      {/* <div className='menu-item'>
        <a
          target='_blank'
          className='menu-link'
          href={process.env.REACT_APP_PREVIEW_DOCS_URL + '/docs/changelog'}
        >
          <span className='menu-icon'>
            <KTSVG path='/media/icons/duotune/general/gen005.svg' className='svg-icon-2' />
          </span>
          <span className='menu-title'>Changelog {process.env.REACT_APP_VERSION}</span>
        </a>
      </div> */}
    </>
  )
}
